import { ImageFields, ImagePreset, Images } from 'types/photo';
import { ParamsSocialsForForm } from 'types/socials';

export enum SOCIALS_TAB_VALUES {
  INFO = 'info',
  STYLING = 'styling',
}

export type SocialsFormValuesProps = ParamsSocialsForForm;

export const SOCIALS_IMAGES_PRESETS: Record<keyof Images, ImagePreset> = {
  [ImageFields.MOBILE]: {
    width: 72,
    height: 72,
    title: 'Мобильная версия',
  },
  [ImageFields.DESKTOP]: {
    width: 72,
    height: 72,
    title: 'ПК версия',
  },
};
